import { render, staticRenderFns } from "./PwaBlob.vue?vue&type=template&id=6b856b3d&scoped=true&"
import script from "./PwaBlob.vue?vue&type=script&lang=js&"
export * from "./PwaBlob.vue?vue&type=script&lang=js&"
import style0 from "./PwaBlob.vue?vue&type=style&index=0&id=6b856b3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b856b3d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
